/**
 * AppRoot - Main routing component for Flux COLD
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProjectsPage from './ProjectsPage';
import ProjectEditor from './ProjectEditor';

export default function AppRoot() {
    return (
        <Routes>
            <Route path="/" element={<ProjectsPage />} />
            <Route path="/:projectId" element={<ProjectEditor />} />
            <Route path="*" element={<Navigate to="/cold-storage" replace />} />
        </Routes>
    );
}
